const typedAs = <TValue,>(val: TValue): TValue => val

export default typedAs
